import React from 'react'
import Slider from 'react-slick'
import PlayMedia from '~/core/components/PlayMedia'
import { Link } from 'react-router-dom'


class NewsSlider extends React.Component {

  render() {
    const slider = this.props.data.map((item, index) =>
      <div key={index}>
        <img src={  '//jeff.4zzz.org.au/' + item.field_news_image.split(',')[0] } style={{ width: '100%', height: 'auto' }} />
        <div className="news-summary">
          <Link to={item.path}><h3>{item.title}</h3></Link>
          <PlayMedia media={'//jeff.4zzz.org.au/' + item.field_news_package_file} />
          <div dangerouslySetInnerHTML={ { __html: item.body } }></div>
        </div>
      </div>
    )
    var settings = {
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
			adaptiveHeight: true
    };
    if (this.props.data.length > 0) {
      return (
        <Slider {...settings}>
          {slider}
        </Slider>
      )
    }
    else {
      return ( null )
    }
  }
}

export default NewsSlider
